export const POSITION_ROOT_LINK_ID = "position";

export const POSITION_DATE_TIME_LINK_ID = "positionDateTime";
export const POSITION_DATE_LINK_ID = "positionDate";
export const POSITION_TIME_LINK_ID = "positionTime";

export const CLIENT_POSITION_LINK_ID = "clientPosition";
export const CLIENT_IN_WATER_LINK_ID = "clientInWater";
export const CLIENT_IN_WATER_OTHER_LINK_ID = "clientInWaterOther";
export const POSITION_NOTES_LINK_ID = "positionNotes";
export const POSITION_SIGNATURE_INITIALS_LINK_ID = "positionSignatureInitials";

export const POSITION_QUESTIONNAIRE_NAME = "position";
